// Player name persistence using localStorage.
// SECURITY NOTE: Only stores first names/nicknames of child players. No PII, no auth tokens,
// no credentials, no email. localStorage is appropriate here as this is a local kids game
// with no authentication system. Static analyzers may flag this as "sensitive data in localStorage"
// — this is a false positive for this app's threat model.

import { logger } from "./logger";

const STORAGE_KEY = 'alba_game_players';

export const savePlayerNames = (names) => {
  try {
    const existing = loadPlayerNames();
    const merged = [...names];
    for (let i = 0; i < 4; i++) {
      if (!merged[i] && existing[i]) merged[i] = existing[i];
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged.slice(0, 4)));
  } catch (err) {
    logger.debug("Failed to save player names", err);
  }
};

export const loadPlayerNames = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    if (data) {
      const parsed = JSON.parse(data);
      if (Array.isArray(parsed)) return parsed.slice(0, 4);
    }
  } catch (err) {
    logger.debug("Failed to load player names", err);
  }
  return ["", "", "", ""];
};
